import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  KivuI18nContext,
  localizedPath,
  PAGE_PORTAL_DASHBOARD,
  PAGE_ROUTE_DOWNLOAD_APPS,
  PAGE_ROUTE_LOGIN,
  PORTAL_PREFIX,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";
import { isEmbeddedShellActive } from "../../Utils/embeddedShellSession";
import { isShowFirstVisitDownloadDialogEnabled } from "../../Utils/firstVisitDownloadDialogEnv";
import AuthContext from "../../context/authContext";
import AppButton from "../common/AppButton";
import { AUTH_STATUS } from "../../context/enums/authEnums";
import { WELCOME_INNER_GAP } from "./welcomeSectionStyles";

const WelcomeHeroActions: React.FC = () => {
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext);
  const { authContextInfo } = useContext(AuthContext);
  const { t } = useKivunovaTranslation();

  const handleGetStarted = () => {
    const path =
      authContextInfo.auth.status === AUTH_STATUS.AUTHENTICATED
        ? `${PORTAL_PREFIX}${PAGE_PORTAL_DASHBOARD}`
        : PAGE_ROUTE_LOGIN;
    navigate(localizedPath(path, language, defaultLang));
  };

  const showDownloadLink =
    !isEmbeddedShellActive() && isShowFirstVisitDownloadDialogEnabled();

  return (
    <>
      <AppButton
        variant="primary"
        size="large"
        onClick={handleGetStarted}
        endIcon={<ArrowForwardIcon />}
        data-testid="login-link"
        sx={{ px: 4, py: 1.5 }}
      >
        {t("get-started-button", "Get Started")}
      </AppButton>
      {showDownloadLink && (
        <Typography
          component="button"
          type="button"
          onClick={() =>
            navigate(
              localizedPath(PAGE_ROUTE_DOWNLOAD_APPS, language, defaultLang)
            )
          }
          sx={{
            mt: WELCOME_INNER_GAP,
            display: "block",
            mx: "auto",
            color: "primary.main",
            textDecoration: "underline",
            cursor: "pointer",
            background: "none",
            border: "none",
            font: "inherit",
            fontSize: "0.95rem"
          }}
          data-testid="welcome-download-apps-link"
        >
          {t(
            "welcome-download-apps-link",
            "Download apps for Windows, Mac, iPhone & Android"
          )}
        </Typography>
      )}
    </>
  );
};

export default WelcomeHeroActions;
